<template>
    <div>
     
        <!-- <h6 class="heading-small text-muted mb-4">Order Items</h6> -->
        <b-overlay :show="loading" rounded="sm">
            
            <b-modal no-close-on-backdrop ref="importModal" @ok="importItems" @cancel="clearItems" body-class="p-0" centered
                header-class="p-0" accordion footer-class="d-flex justify-content-center border-0"
                content-class="custom-model-wrap" size="lg">
                <template #modal-header="{ cancel }">
                    <div class="title-block text-center p-2">{{ modalTitle }}</div>
                    <button type="button" id="close-manage-order-item-model" @click="cancel()" aria-label="Close" class="close">
                        ×
                    </button>
                </template>
                <b-card no-body>
                    <b-card-body class="p-0 manage-order-item-popup">
                        <div>
                            <h6 class="text-center mb-2 col-12" v-if="template_primary_items.length > 0 &&
                                template_secondary_items.length > 0
                                ">
                                <strong> {{ $translate('primary_items') }} </strong>
                            </h6>
                            <b-table class="m-3" v-if="is_items_mode" :items="template_primary_items" :fields="fields">
                                <template #head(id)>
                                    <h6 class="pr-2" style="font-weight: bold">
                                        {{ $translate('no') }}
                                    </h6>
                                </template>
                                <template #head(order_item_type_id)>
                                    <h6 class="pr-2" style="font-weight: bold">
                                        {{ $translate('type') }}
                                    </h6>
                                </template>
                                <template #cell(id)="{ index }">
                                    <h6>
                                        {{ index + 1 }}
                                    </h6>
                                </template>

                                <template #cell(order_item_type_id)="{ value }">
                                    <h6>
                                        {{ value | filterTypeName(itemTypes) }}
                                    </h6>
                                </template>
                            </b-table>
                        </div>
                        <div class="mt-4" v-if="template_secondary_items.length > 0">
                            <h6 class="text-center mb-2 col-12">
                                <strong>
                                    {{ $translate('secondary_items') }}
                                </strong>
                            </h6>
                            <b-table class="m-3" v-if="is_items_mode" :items="template_secondary_items" :fields="fields">
                                <template #head(id)>
                                    <h6 class="pr-2" style="font-weight: bold">
                                        {{ $translate('no') }}
                                    </h6>
                                </template>
                                <template #head(order_item_type_id)>
                                    <h6 class="pr-2" style="font-weight: bold">
                                        {{ $translate('type') }}
                                    </h6>
                                </template>
                                <template #cell(id)="{ index }">
                                    <h6>
                                        {{ index + 1 }}
                                    </h6>
                                </template>

                                <template #cell(order_item_type_id)="{ value }">
                                    <h6>
                                        {{ value | filterTypeName(itemTypes) }}
                                    </h6>
                                </template>
                            </b-table>
                        </div>
                        <show-recent-orders v-if="!is_items_mode && is_recent_import" v-model="selected_order_id"
                            :order_type_id="orderModel.order_type_id" :customer_id="orderModel.customer_id"
                            @set-items="items => setRecentOrderItems(items)" />
                        <select-order-template v-if="!is_items_mode && !is_recent_import"
                            v-model="orderModel.order_template_id" :order_category_id="order_category_id"
                            :orderTemplateId="order_category_id" :include-items="true"
                            :order-type-id="orderModel.order_type_id" @set-items="items => setTemplateItems(items)" />
                    </b-card-body>
                    <b-card-body class="py-0" v-if="orderModel.customer_id">
                        <view-assets v-model="linked_assets" :customer_id="orderModel.customer_id"
                            :customer-assets="customerAssets" :disabled="false" />
                    </b-card-body>
                </b-card>

                <template #modal-footer="{ ok, cancel }">
                    <b-button id="order-clear-item-btn" v-if="is_items_mode" variant="info" @click="clearItems">
                        <b-icon icon="arrow-clockwise"></b-icon>
                    </b-button>

                    <b-button id="order-import-item-btn" size="fw" variant="info" @click="ok()" v-if="is_items_mode">
                        {{ $translate('import_items') }}
                    </b-button>

                    <b-button id="order-cancel-item-btn" size="fw" variant="info" class="btn-fw" @click="cancel()">
                        {{ $cancelLabel() }}
                    </b-button>
                </template>
            </b-modal>
        </b-overlay>

        <template>
          
            <b-alert show v-if="is_secondary">{{ order.type.name }}</b-alert>
            <div v-for="(item, idx) in filteredItemTypeOptions" :key="`primary-items${item.id}`" class="accordion-box">
                <a :id="'item-accordion-'+item.id" block href="javascript:void(0)" v-b-toggle="'accordion' + item.id"
                    :class="{ 'active-accordion': accordianModelArray[idx+1] }" variant="light"
                    class="accordion-header left-sign">
                    <span> {{ item.name }}</span>
                </a>
                <b-collapse :id="'accordion' + item.id" role="tabpanel" v-model="accordianModelArray[idx+1]">
                    <DisplayOrderItems key="primary-items" :tableIndex="idx + 1" :filtered-items="listTypeItems(item.id)"
                        :customer-assets="customerAssets" :item-type-id="item.id" :viewMode="viewMode" :isNew="isNew"
                        @toggleAssignment="hideTotals = $event" @view-item="hash => setItemView(hash)"
                        @order-status="getOrderCompletionStatus">
                    </DisplayOrderItems>
                </b-collapse>
            </div>
            <b-alert show v-if="is_secondary">{{
                secondary_order.type.name
            }}</b-alert>
            <div v-for="(item, idx) in secondaryItemTypeOptions" :key="`secondary-items${item.id}`" class="accordion-box">
                <a :id="'secondary-items-accordion-'+item.id" block href="javascript:void(0)" v-b-toggle="'accordion' + item.id"
                    :class="{ 'active-accordion': accordianModelArray[idx+1] }" variant="light"
                    class="accordion-header left-sign">
                    <span> {{ item.name }}</span>
                </a>
                <b-collapse :id="'accordion' + item.id" role="tabpanel" v-model="accordianModelArray[idx+1]">
                    <DisplayOrderItems key="secondary-items" :tableIndex="idx + 2"
                        :filtered-items="listTypeItems(item.id, true)" :customer-assets="customerAssets"
                        :item-type-id="item.id" :viewMode="true" :isNew="false" @toggleAssignment="hideTotals = $event"
                        @view-item="hash => setItemView(hash, true)" @order-status="getOrderCompletionStatus">
                    </DisplayOrderItems>
                </b-collapse>
            </div>
        </template>
        
        <view-item ref="viewItem" :order-model="orderModel" :officer="officer" @set-deposit="evt => setDeposit(evt)" :customer-assets="customerAssets" />

     

        <ViewDiscount :order-model="orderModel" ref="viewDiscount" />
        <show-recent-orders v-if="!is_items_mode && is_recent_import" v-model="selected_order_id"
        :order_type_id="orderModel.order_type_id" :customer_id="orderModel.customer_id"
        @set-items="items => setRecentOrderItems(items)" />
       
    </div>
</template>

<script>
import EventBus from '@/exports/event-bus.js'
import DisplayOrderItems from './DisplayOrderItems.vue'


import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import ViewItem from './ViewItem'

import ViewDiscount from './ViewDiscount.vue'
import SelectOrderTemplate from '@/components/SelectOrderTemplate.vue'
import ShowRecentOrders from './ShowRecentOrders.vue'


import ViewAssets from '@/components/ViewAssets'

export default {
    name: 'orders-items',
    components: {
        DisplayOrderItems,
       
        ViewItem,
        ShowRecentOrders,
      
        ViewDiscount,
        SelectOrderTemplate,
      
    },
    mixins: [popupMixins, permissionsMixins],
    data() {
        return {
            isPaymentVisible: false,
            accordianModelArray: [],
            accordianModelDepositArray : [],
            submitting: false,
            hideTotals: false,
            genratedItems: false,
            orderModel: {},
            loading: false,
            linked_assets: [],
            order_category_id: null,
            /////////////////////
            selected_order_id: null,
            is_recent_import: false,
            is_items_mode: false,
            template_primary_items: [],
            template_secondary_items: [],
            visible: [0],
            loadedItemTypes: [],
            orderStatus: 0,
            collapseIndex: null,
            secondary_order: null,
            payment_item: {},
            // customerAssets:[],
            deposit_of_invoice_total : 0,
            deposit_of_invoice_total_amount :0,
            deposit_rental_item_value : 0,
            deposit_rental_item_value_amount :0,
            deposit_flat_amount: 0,
            total_deposit_required:0,
            total_rental_selling :0,
            total_rental_estimated :0,
            default_rental_days : 1,
            isDetailsVisible: false, 
            Handle1: true,
            Handle2: true,
            Handle3: true,
            Handle4:true,
            show_deposit  :false,

        }
    },
    props: {
        viewMode: { type: Boolean, default: false },
        isNew: { type: Boolean, default: false },
        customerAssets: { type: Array, require: true },
        order: { type: Object, require: true },
        showDeposit : { type: Boolean, default: false },
    },
    filters: {
        currency: num => {
            num = parseFloat(num)
            try {
                return num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
            } catch (err) {
                return '0.00'
            }
        },
        capitalize: function (value) {
            if (!value) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        },
        displayTypeName(id, types) {
            console.log('types', types)
            return (types.find(x => x.id == id) || {}).name
        },
        filterTypeName(value, types) {
            return (types.find(x => x.id == value) || {}).name
        },
    },

    computed: {
        displayTotalsIfPositive(){
            return ((this.itemsTotals.total+this.rentalTotals.total) > 0 || this.adjustmentTotals.total > 0 || this.grandTotal > 0 || this.totalPaid > 0 || this.totalBalance > 0)
        },
        orderTypes() {
            return this.$store.getters["orderType/activityTypesByPermission"].filter(
                (x) => x
            );
        },
        rentalAllowable(){
            if (this.orderModel.order_type_id) {
                const _orderType =
                this.orderTypes.find((x) => x.id === this.orderModel.order_type_id) ||
                {};
                return _orderType.rental_allowable;
            }
            return false;
        },
        fields() {
            return [
                { key: 'id', label: '' },
                { key: 'name', label: this.$translate('name') },
                { key: 'order_item_type_id', label: this.$translate('type') },
                { key: 'quantity', label: this.$translate('quantity') },
            ]
        },
        paymentRoute() {
            return `/ams/payments?q=&order_search=${this.order.reference_no}`
        },
        modalTitle() {
            return this.is_items_mode && this.is_recent_import
                ? this.$translate('selected_activity_items')
                : this.is_items_mode
                    ? this.$translate('selected_template_items')
                    : this.is_recent_import
                        ? this.$translate('recent_activities')
                        : this.$translate('activity_template')
        },
        tabOneTitle() {
            return this.is_items_mode
                ? this.$translate('items')
                : this.is_recent_import
                    ? this.$translate('activity')
                    : this.$translate('templates')
        },
        itemTypeOptions() {
            return this.itemTypes.map(x => ({
                value: x.id,
                text: x.name,
            }))
        },

        filteredItemTypeOptions() {
            const { selectedItemType, onlyUnique } = this

            const list = this.storedItems
                .map(i => i.order_item_type_id)
                .filter(onlyUnique)
                .map(selectedItemType)
                .filter(item => item !== undefined)

            console.log('filteredItemTypeOptions', list)

            return list
        },

        is_secondary() {
            return this.secondaryItemTypeOptions.length > 0
        },

        secondaryItems() {
            return this.$store.state.orderItemStore.secondary_items
        },

        secondaryItemTypeOptions() {
            const { selectedItemType, onlyUnique, secondaryItems } = this
            console.log('secondaryItems',secondaryItems)
            const list = secondaryItems &&
                secondaryItems 
                .map(i => i.order_item_type_id)
                .filter(onlyUnique)
                .map(selectedItemType)
                .filter(item => item !== undefined) || []

            console.log('secondaryItemTypeOptions', list)

            return list
        },
        orderItemPrice() {
            const total = this.itemsTotals.total > 0
            return total
        },
        orderAssetRentalItemPrice() {
            const total = this.rentalTotals.total > 0
            console.log('orderAssetRentalItemPrice', total)
            return total
        },
        storedItems() {
            return this.$store.getters['orderItemStore/itemsOnly']
        },

        storedRentalAssets() {
            return this.$store.getters['orderRentalAssetStore/itemsOnly']
        },

        itemTypes() {
            return this.$store.state.itemType.items
        },
        hasPricing() {
            return this.$store.getters['orderItemStore/hasPricing']
        },
        hasPricingAsset() {
            return this.$store.getters['orderRentalAssetStore/hasPricing']
        },

        itemsTotals() {
            return this.$store.getters['orderItemStore/itemsTotals']
        },

        rentalTotals() {
            return this.$store.getters['orderRentalAssetStore/itemsTotals']
        },
        rentaladjustmentTotals() {
            return this.$store.getters['orderRentalAssetStore/adjustmentTotals']
        },
        adjustmentTotals() {
            return this.$store.getters['orderItemStore/adjustmentTotals']
        },
        discountTitle() {
            return this.adjustmentItems.length
                ? this.$translate('change_discount')
                : this.$translate('add_discount')
        },

        adjustmentItems() {
            return this.$store.getters['orderItemStore/adjustmentItems']
        },

        officer() {
            return this.$store.state.users.user
        },

        orderItems() {
            return this.$store.state.orders.orderItems
        },

        orderAssetRentalItems() {
            console.log('this.$store.state.orders.orderAssetRentalItems', this.$store.state.orders.orderAssetRentalItems)
            return this.$store.state.orders.orderAssetRentalItems
        },
        selectedTemplate() {
            return this.$store.state.orderTemplate.selectedTemplate
        },
        grandTotal(){
            return (
                this.itemsTotals.tax +
                this.itemsTotals.total +
                this.adjustmentTotals.total +
                this.adjustmentTotals.tax+
                this.rentalTotals.tax +
                this.rentalTotals.total 
            );
        },
        totalPaid(){
            return parseFloat(this.order.total_payments_and_credits) || 0
            // return (this.order.processed_payments_incoming_sum_payment_amount - this.order.processed_payments_outgoing_sum_payment_amount) || 0
        },
        totalBalance(){
            return parseFloat(this.order.total_balance) || 0
            // return this.grandTotal - ((this.order.processed_payments_incoming_sum_payment_amount - this.order.processed_payments_outgoing_sum_payment_amount) || 0)
        },
        allowToAddPayment() {
            return !!this.user_permissions.includes(
              "create.payment.transaction"
             );
        },
        allowToViewPayment() {
            return !!this.user_permissions.includes(
              "view.payment.transaction"
             );
        },
        assets() {
            return this.$store.state.assets.assets || []
        },
        assets_rental() {

            console.log('the asset rental items are :',this.$store.state.orderRentalAssetStore.items);
            return this.$store.state.orderRentalAssetStore.items || []
        },
        allowToViewDeposit(){

        console.log('show deposit---------',this.$store.state.orders.show_deposit);
            return this.$store.state.orders.show_deposit; 
        }
        
    },
    watch: {
        officer: {
            handler: function (_officer, from) {
                console.log('ManageOrderItems watch officer', {
                    _officer,
                    from,
                })
                const { location_section_id } = _officer
                this.$store.dispatch(
                    'masterItem/fetchBySection',
                    location_section_id
                )
            },
            deep: true,
        },
        storedItems: {
            handler: function (items) {
                console.log('stored items', items)
            },
            deep: true,
        },
        storedRentalAssets:{
            handler: function (items) {
                console.log('stored rental asssets', items)
            },
            deep: true,

        },
        orderItems: {
            //load items
            handler: function (items) {
                this.loaditems(items)
            },
            deep: true,
        },

        orderAssetRentalItems: {
            //load items
            handler: function (items) {
                this.loadAssetRentalitems(items)
            },
            deep: true,
        },

        filteredItemTypeOptions: {
            handler: function (val) {
                this.generateItems(val)
            },
            deep: true,
        },
        'orderModel.order_template_id': {
            handler: function (template_id) {
                EventBus.$emit('update-order-template', template_id)
            },
            deep: true,
        },
        // selectedTemplate: {
        //     handler: function () {
        //         this.importItems()
        //     },
        //     deep: true,
        // },
        order: {
            handler: function (val) {
                console.log('order------------', val)
                const { order_template, secondary_orders } = val
                const { secondary_order_type_id } = order_template || {}
                if (!secondary_order_type_id) return

                //////////////////////////////////////////
                this.getSecondaryOrders(secondary_orders).then(_orders => {
                    console.log('secondary orders---------', _orders)
                    this.secondary_order = _orders.find(
                        x => x.order_type_id == secondary_order_type_id
                    )

                    const { items } = this.secondary_order || {}
                    const secondaryItems = (items || []).map(x => {
                        x.quantity = -x.quantity
                        return x
                    })

                    this.$store.commit(
                        'orderItemStore/SET_SECONDARY_ITEMS',
                        secondaryItems
                    )
                })
                
            },
            deep: true,
        },
        
        'deposit_of_invoice_total': {
            handler: async function (value) {
               
               await this.$store.commit('orders/SetDepositOfInvoiceTotal', value);
           
                this.updateTotalDepositRequired();
            },
            deep: true,
        },
        'deposit_rental_item_value': {
            handler: async function (value) {
                await this.$store.commit('orders/SetDepositRentalItemValue', value);
                this.updateTotalDepositRequired();
            },
            deep: true,
        },
        'deposit_flat_amount': {
            handler: async function (value) {
               await  this.$store.commit('orders/SetDepositFlatAmount', value);
                this.updateTotalDepositRequired();
            },
            deep: true,
        },
        'default_rental_days': {
            handler: async function (value) {
               await   this.$store.commit('orders/SetRentalDays', value);
                this.updateTotalDepositRequired();
            },
            deep: true,
        },
        'assets_rental.length' : {
            handler: async function (value) {
                this.updateTotalDepositRequired();
            },
            deep: true,

        },
        allowToViewDeposit(newValue) {
            this.show_deposit = newValue; // or any other logic you want to apply
        },
    
    },
    async mounted() {
        const { orderItems, orderAssetRentalItems } = this

        console.log('orderItems--',orderItems);
        await this.loadAssetRentalitems(orderAssetRentalItems)
        await this.$nextTick()
        await this.loaditems(orderItems)
        await this.$nextTick()
        this.loadedItemTypes = this.getLoadedItemTypes(orderItems)
        //Set the visible array. This array controls the visible accordian tabs
        // this.visible =  [...Array(this.loaditems.length)].fill(true)
        console.log('this.storedItems', this.storedItems)
        // console.log('this.storedRentalAssets', this.storedRentalAssets)
        this.generateItems(this.filteredItemTypeOptions)
        console.log('accordion model', this.accordianModelArray)
      
        // console.log('this order detail ',this.order.id)
        // this.fetchRentalAssetsIfOrderIdAvailable(orderId);
        //set selling price 

      
    },
    beforeDestroy() {
        EventBus.$off('set-template');
        // EventBus.$off('set-rental-allowable');
    },
    created() {
        let $this = this
        EventBus.$on('set-template', async (value) => {
            this.deleteGenratedTemplate()
            if (value) {
                this.loading = true
                await this.$store.dispatch('orderTemplate/fetchById', value)
                this.$nextTick(() => {
                    this.setimportItems(value)
                    this.orderModel.order_template_id = value
                })

            }
        })
        EventBus.$on('reset-template', async (value) => {
            this.deleteGenratedTemplate()
        
        })
        EventBus.$on('set-rental-allowable', (value) => {
            $this.orderModel.rental_allowable = value
            console.log('this.orderModel.rental_allowable', $this.orderModel)
        })
        EventBus.$on('trigger-add-item', () => {
            console.log('ManageOrderItems triggered........')
            this.setItemView()
        })
        EventBus.$on(
            'set-order-model',
            ({
                order: {
                    order_type_id,
                    customer_id,
                    completed,
                    driver_id,
                    delivery_location_section_id,
                    order_template_id,
                    id,
                    reference_no,
                    released,
                },
            }) => {
                this.$nextTick(() => {
                    ///// load officer
                    console.log(
                        'set-order-model-------------------',
                        order_type_id
                    )
                    if (driver_id && this.orderModel.driver_id != driver_id) {
                        this.$store.dispatch('users/fetchUser', driver_id)
                    }

                    this.orderModel = {
                        order_type_id,
                        customer_id,
                        completed,
                        driver_id,
                        delivery_location_section_id,
                        order_template_id,
                        id,
                        reference_no,
                        released,
                    }
                    ///console.log('EventBux Order trigger', this.orderItems)
                    // this.loaditems(this.orderItems, 'EventBus')
                })
            }
        );
      

        // console.log('values--------------', this.orderModel.deposit_rental_item_value,  this.orderModel.deposit_of_invoice_total, this.orderModel.deposit_flat_amount);
    },
    methods: {
        onlyUnique(value, index, array) {
            return array.indexOf(value) === index
        },
        selectedItemType(id) {
            const { itemTypes } = this
            return (itemTypes || []).find(t => t.id == id)
        },
        async getSecondaryOrders(_orders) {
            const { $store } = this
            return await Promise.all(
                _orders.map(x =>
                    $store.dispatch(
                        'orders/fetchByIdDirect',
                        x.secondary_order_id
                    )
                )
            )
        },
        listTypeItems(id, is_secondary) {
            console.log('items-----',this.storedItems);
            return (
                is_secondary ? this.secondaryItems : this.storedItems
            ).filter(x => x.order_item_type_id == id )
        },
        generateItems(items) {
            // if(items.length < 1) return;
            if (this.orderAssetRentalItems.length > 0 && this.assets_rental.length > 0) {
                console.log('yes=-------', this.accordianModelArray)
                this.accordianModelArray.splice(1)
            } else if(this.orderAssetRentalItems.length > 0) {
                console.log('no=-------', this.accordianModelArray)
                this.accordianModelArray.splice(0)
            }
            this.accordianModelArray.push(
                ...[...Array(items.length).keys()].map(() => true)
            )
        },
        loaditems(items) {
            console.log(`loaditems items`, items)
            const cloneItems = []
            for (const item of items) {
                const _item = { ...item }
                const assets = _item.assets.map(i => i.asset_id)
                this.$set(_item, 'assets', assets)
                cloneItems.push(_item)
            }
            this.$store.dispatch('orderItemStore/load', cloneItems);
           
        },
        async loadAssetRentalitems(items) {
            console.log(`loadAssetRentalitems items`, items)
            this.accordianModelArray[0] = true
            // const cloneItems = []
            // for (const item of items) {
            //     const _item = { ...item }
            //     const assets = _item.assets.map(i => i.asset_id)
            //     this.$set(_item, 'assets', assets)
            //     cloneItems.push(_item)
            // }
            await this.$store.dispatch('orderRentalAssetStore/load', items)
        },
        clearItems() {
            this.is_items_mode = false
            this.orderModel.order_template_id = null
            this.selected_order_id = null
            this.template_primary_items.splice(0, this.template_primary_items.length)
            this.template_secondary_items.splice(0, this.template_secondary_items.length)
        },
        showItemModal(is_recent_type) {
            this.is_recent_import = !!is_recent_type
            this.clearItems()
            this.$refs['importModal'].show()
        },
        // showPaymentModal() {
        //     this.$refs['paymentModal'].show()
        // },
        setItemView(hash, is_secondary = false) {
            console.log('item hash', hash)
            const { storedItems, secondaryItems, order, secondary_order } = this

            let item = null
            let order_type_id = null
            let reference_no = null
            let viewMode = true

            if (is_secondary) {
                item = secondaryItems.find(x => x.hash === hash)
                order_type_id = secondary_order?.order_type_id
                reference_no = secondary_order?.reference_no
            } else {
                item = storedItems.find(x => x.hash === hash)
                reference_no = order?.reference_no
                order_type_id = order?.order_type_id
                viewMode = this.viewMode
            }

            this.$refs['viewItem'] &&
                this.$refs['viewItem'].showItem(item, {
                    reference_no,
                    viewMode,
                    order_type_id,
                })
        },
        setAssetItemView(hash) {
            console.log('asset item hash', hash)
            const { storedRentalAssets, order } = this

            let order_type_id = null
            let reference_no = null
            let viewMode = true

            
            let item = storedRentalAssets.find(x => x.hash === hash) || null
            if(item){

                
                reference_no = order?.reference_no
                order_type_id = order?.order_type_id
                viewMode = this.viewMode
            }

            this.$refs['viewAssetItem'] &&
                this.$refs['viewAssetItem'].showItem(item, {
                    reference_no,
                    viewMode,
                    order_type_id,
                })
        },

        returnAssetItemView(hash) {
            console.log('asset item hash', hash)
            const { storedRentalAssets, order } = this

            let order_type_id = null
            let reference_no = null
            let viewMode = true
            let isReturnMode = true

            
            let item = storedRentalAssets.find(x => x.hash === hash) || null
            if(item){

                
                reference_no = order?.reference_no
                order_type_id = order?.order_type_id
                viewMode = this.viewMode
            }

            this.$refs['viewAssetItem'] &&
                this.$refs['viewAssetItem'].showItem(item, {
                    reference_no,
                    viewMode,
                    order_type_id,
                    isReturnMode,
                })
        },

        setDiscountView(hash) {
            console.log('item hash', hash)
            const item = this.storedItems.find(x => x.hash === hash)
            this.$refs['viewDiscount'] &&
                this.$refs['viewDiscount'].showItem(item)
        },
        setRecentOrderItems(items) {
            items = items || []
            console.log(
                'template items',
                items.filter(x => !x.is_secondary_order_type)
            )
            this.template_primary_items.splice(0, this.template_primary_items.length)
            this.template_primary_items.push(
                ...items.map(({ name, master_item, quantity, item_type, item }) => ({
                    name,
                    order_item_type_id: item_type?.id,
                    quantity,
                    ...master_item,
                    item,
                }))
            )
            this.is_items_mode = true
        },
        setTemplateItems(items) {
            items = items || []
            console.log('template items:', items)
            this.template_primary_items.splice(0, this.template_primary_items.length)
            this.template_secondary_items.splice(0, this.template_secondary_items.length)

            for (const item of items) {
                const {
                    master_item,
                    default_quantity: quantity,
                    is_secondary_order_type,
                } = item
                if (!is_secondary_order_type) {
                    this.template_primary_items.push({
                        ...master_item,
                        quantity,
                        is_template_item: true,
                        customer_completion : item.customer_completion
                    })
                } else {
                    this.template_secondary_items.push({
                        ...master_item,
                        quantity,
                    })
                }
            }

            this.is_items_mode = true
        },
        deleteTemplateItems() {
            for (const item of this.storedItems.filter(
                x => x.is_template_item
            )) {
                this.$store.dispatch('orderItemStore/delete', item.hash)
            }
            this.orderModel.order_template_id = undefined
        },
        async deleteGenratedTemplate() {
            this.template_primary_items.splice(0, this.template_primary_items.length)
            await this.$store.dispatch('orderItemStore/deleteTemplate')
        },
        getLoadedItemTypes(orderItems) {
            const itemTypes = orderItems

            console.log('ORDER ITEM TYPES LOADED: ', itemTypes)
            return itemTypes
        },
        toggleCollapses(ids) {
            ids.forEach(id => {
                this.$root.$emit('bv::toggle::collapse', id)
            })
        },
        getOrderCompletionStatus(value) {
            console.log('^^^^^^^^^^^ Completion Status', value)
        },
        async setimportItems(orderTemplateId) {
            try {
                for (const item of this.selectedTemplate && this.selectedTemplate.items) {
                    const {
                        master_item,
                        order_template_id,
                        default_quantity: quantity,
                        is_secondary_order_type,
                    } = item
                    if (!is_secondary_order_type) {
                        this.template_primary_items.push({
                            ...master_item,
                            order_template_id,
                            quantity,
                            is_template_item: true,
                            customer_completion:item.customer_completion
                        })
                    }
                }
                let primaryItems = this.template_primary_items.filter(x => x.order_template_id == orderTemplateId)
                this.genrateItems(primaryItems)
            } catch (error) {
                console.error(error)

            }
        },

        async genrateItems(primaryItems) {
            try {
                const fixItem = item => {
                    item.assets = this.linked_assets
                    item.master_item_id = item.id
                    item.price = item?.selling_price ?? item?.price
                    item.tax_rate = item?.type?.tax_rate ?? item?.tax_rate
                    item.section_from_id = null
                    item.section_to_id = null
                    item.id = null
                }
                for (const item of primaryItems) {
                    fixItem(item)
                    await this.$store.dispatch('orderItemStore/merge', item)
                }
            } catch (error) {
                console.err(error)
            } finally {
                
                this.loading = false
            }

        },
        async importItems() {
            const fixItem = item => {
                item.assets = this.linked_assets
                item.master_item_id = item.id
                item.price = item?.selling_price ?? item?.price
                item.tax_rate = item?.type?.tax_rate ?? item?.tax_rate
                item.section_from_id = null
                item.section_to_id = null
                item.id = null
            }
            for (const item of this.template_primary_items) {
                fixItem(item)
                console.log('import item', item)
                await this.$store.dispatch('orderItemStore/merge', item)
            }

            this.updateTotalDepositRequired();
            this.$refs['importModal'].hide()
        },
        async setNewPaymentForm() {
            this.isPaymentVisible = !this.isPaymentVisible;
        },
        async resetItems(status) {
            await this.$store.dispatch('orders/fetchById', this.$route.params.id)
            this.genericToast(
                this.$translate('payment'),
                status,
                'success',
                `${this.$translate('payment')} ${status.toLowerCase()} ${this.$translate('succcessfully')}`
            )
        },
        itemAdded(evt){
            // this.accordianModelArray.push(true)
            console.log('evt', evt, this.accordianModelArray)
        },
        setDeposit(evt){
            this.updateTotalDepositRequired();
        },
        async updateTotalDepositRequired() {
            console.log('this.assets_rental---------------',this.assets_rental);
            this.deposit_rental_item_value =  this.$store.getters['orders/depositRentalItemValue'];
            this.deposit_of_invoice_total = this.$store.getters['orders/depositOfInvoiceTotal'];
            this.deposit_flat_amount = this.$store.getters['orders/depositFlatAmount'];
            this.default_rental_days  = this.$store.getters['orders/rentalDays'];

            console.log('values are changed===========', this.deposit_rental_item_value,this.deposit_of_invoice_total,this.deposit_flat_amount);
            var final_item_amount = 0; 
            var final_asset_amount = 0; 
            var rental_amount = 0; 
            var rental_estimated = 0;
            //count item total 
             if(this.deposit_of_invoice_total > 0 && this.deposit_of_invoice_total != "" ){
               final_item_amount = ((this.grandTotal)*this.deposit_of_invoice_total / 100);
             }
             console.log('this.grandtotal_final_amount------------------',final_item_amount);
             if(this.assets_rental.length > 0){
                this.assets_rental.forEach(asset => {
                    console.log('result----------',asset);
                    const result = (Number(asset?.asset?.master_item?.selling_price??0) * Number(this.deposit_rental_item_value ?? 0)) / 100;
                    console.log('result----------',result);
                     rental_amount += Number(asset?.asset?.master_item?.selling_price??0);
                     rental_estimated+=Number(asset?.asset?.master_item?.default_rental_rate??0);
                   
                    const rental_rate = Number(asset?.asset?.master_item?.default_rental_rate??0) * Number(this.default_rental_days ?? 1);
                    final_asset_amount+= result+rental_rate;
                    console.log('final_asset_amount',final_asset_amount);
                });
                this.total_rental_selling = rental_amount;
                this.total_rental_estimated = rental_estimated;
             }
            this.total_deposit_required =
            Number(final_item_amount ?? 0) +
            Number(final_asset_amount ?? 0) +
            Number(this.deposit_flat_amount ?? 0);
            this.total_deposit_required = parseFloat(this.total_deposit_required.toFixed(2));
            this.$store.commit('orders/SetTotalDepositAmount', this.total_deposit_required);
            
            console.log('total deposit------------- ',final_item_amount,final_asset_amount,this.total_deposit_required)
        },
        toggleDetails() {
            this.isDetailsVisible = !this.isDetailsVisible;
        },
        handleClick(flag) {
        if (flag) {
            this[flag] = false;// Remove the background color after the first click
        }
        }
    },
    destroyed() {
        EventBus.$off('set-order-model');
    },
   
}
</script>
<style></style>
